import React, {useState} from 'react';
import {Controller} from 'react-hook-form';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Translate, useTranslation} from '../../../config/TranslationProvider';

const weekdays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    },
    textField: {
        flex: '2 1 auto',
        margin: '0 10px',
    },
}));


const OpeningHours = ({register, control, selected}) => {
    const classes = useStyles();
    const [showTimes, setShowTimes] = useState(!!selected?.weekday);
    const [showDescription, setShowDescription] = useState(false);

    const handleMouseClick = () => setShowDescription(prev => !prev);

    const handleWeekdayChange = e => {
        if (e.target.value !== '') {
            setShowTimes(true);
        } else {
            setShowTimes(false);
        }
    };

    return (
        <div className="filter-checklist">
            <fieldset>
                <legend>
                    <Translate value="opening_hours" />
                    <button
                        className="action-btn"
                        type="button"
                        aria-label={useTranslation('opening_hours_info_label')}
                        aria-controls="openingHoursInfo"
                        onClick={handleMouseClick}
                    >
                        <span className="la la-info-circle"  />
                    </button>
                </legend>

                {showDescription &&
                    <p id="openingHoursInfo" className="filter-info">
                        <Translate value="opening_hours_info" />
                    </p>
                }

                <div className="form-group" style={{width: '100%', marginBottom: '0.5rem'}}>
                    <div className="select-basic">
                        <select
                            className="form-control"
                            name="opening_hours[weekday]"
                            ref={register}
                            defaultValue={selected?.weekday || ''}
                            onChange={handleWeekdayChange}
                            aria-label={useTranslation('select_weekday')}
                        >
                            <option value="">
                                {useTranslation('select_weekday')}
                            </option>
                            {weekdays.map((weekday, key) => (
                                <option key={key} value={key + 1}>
                                    {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                    {useTranslation(weekday)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {showTimes && (
                    <div className={classes.container}>
                        <Controller
                            control={control}
                            as={<TextField />}
                            name="opening_hours[start]"
                            type="time"
                            label="Von"
                            defaultValue={selected?.start}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <Controller
                            control={control}
                            as={<TextField />}
                            name="opening_hours[end]"
                            type="time"
                            label="Bis"
                            defaultValue={selected?.end}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                )}
            </fieldset>

        </div>
    );
};

export default OpeningHours;
